import { atom } from 'jotai';

export const isSearchOpen = atom<boolean>(false);

// 체크리스트(write) 메모 토글 상태
export const commentWriteToggleStates = atom<Record<string, boolean>>({});
